import { useNavigate } from "react-router-dom";
import { UserAccountConfirmedPageTemplate } from "./template";

export const UserAccountConfirmedPage = (): JSX.Element => {
  const navigate = useNavigate();
  return (
    <UserAccountConfirmedPageTemplate onSignInClick={() => navigate("/signin")} />
  );
}; 